import { useCallback } from "react";
import type { Shift } from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";

export const useFetchShift = (shiftId?: string | null): UseFetchActionReturn<Shift | undefined> => {
    const fetchShift: () => Promise<Shift | undefined> = useCallback(() => {
        if (shiftId) {
            return store.shiftsApi.shiftsReadShift({ shiftId });
        } else {
            return Promise.resolve(undefined);
        }
    }, [shiftId]);
    return useFetchAction(fetchShift);
};
